import React, { Component } from 'react';

require('./authentication.css');
//require('firebase/firestore');

var firebase = require('firebase');
//var db = firebase.firestore();
var googleProvider = new firebase.auth.GoogleAuthProvider();

class Authentication extends Component {
    constructor(props) {
        super(props);
        this.loginWithProviders = this.loginWithProviders.bind(this);
    }

    loginWithProviders(provider) {
        console.log(provider.toString());

        //Sign in With Google. 
        if (provider === "google") {
            try {
                firebase.auth().signInWithRedirect(googleProvider);
                //Redirected
                firebase.auth().getRedirectResult().then(function (result) {
                    /**
                     * Need to figure out where this goes and if necessary. 
                     
                    if (result.credential) {
                        // This gives you a Google Access Token. You can use it to access the Google API.
                        var token = result.credential.accessToken;
                        console.log("Token \n: " + token);
                    }
                    //The Signed-in user's info
                    var user = result.user;
                    console.log("User: " + user); */
                }).catch(function (error) {
                    //Handle Error here
                    //var errorCode = error.code, errorMessage = error.message;
                    //var email = error.email; var credential = error.credential;
                    console.log("Error Info: " + error);
                });
            } catch (error) {
                console.error("Error Signinng in with Google: " + error.toString());
            }
        }
        

    }


    render() {
        return (
            <div id="loginPage">
                <div className="container text-center">
                    <h2>Login</h2>
                    <hr />
                    <div className="card loginCard">
                        <div className="card-block">
                            <br />
                            <button className="btn btn-lg btn-danger login_buttons"
                                type="button" id="googleLoginButton" onClick={() => this.loginWithProviders('google')}>
                                <i className="fab fa-google"></i> | Login with Google
                            </button>
                            <button className="btn btn-lg btn-primary login_buttons"
                                type="button" id="facebookLoginButton" onClick={() => this.loginWithProviders('facebook')}>
                                <i className="fab fa-github"></i> | Login with Github
                            </button>
                            <button className="btn btn-lg btn-info login_buttons"
                                type="button" id="emailLoginButton" onClick={() => this.loginWithProviders('email')}>
                                <i className="fas fa-at"></i> | Login with Email
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Authentication;



// WEBPACK FOOTER //
// ./src/Authentication/Authentication.js